import React from "react";
import { motion } from "framer-motion";
import { Typography } from "../DesignSystem";
import type { StepConfig } from "../../types";

interface FormStepProps {
  config: StepConfig;
  children: React.ReactNode;
}

const stepVariants = {
  initial: { opacity: 0, x: 20 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -20 },
};

const FormStep: React.FC<FormStepProps> = ({ config, children }) => {
  return (
    <motion.div
      key={config.id}
      variants={stepVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.3 }}
      className="min-h-0"
    >
      {/* Always show headline first - serif font, text color */}
      {config.title && (
        <Typography
          as="h2"
          variant="h3"
          color="default"
          className="mb-3 pt-2 sm:pt-4 font-serif"
        >
          {config.title}
        </Typography>
      )}
      {/* Description always under headline */}
      {config.subtitle && (
        <Typography variant="description" color="muted" className="mb-6">
          {config.subtitle}
        </Typography>
      )}
      {children}
    </motion.div>
  );
};

export default FormStep;
